export function formatAnalystNotesForDisplay(analystNotes?: string | null): string {
  return analystNotes && analystNotes.trim() !== ''
    ? analystNotes
    : 'sin comentarios';
}
